import "./universal.js";

// Import stylesheets
import "/css/firebase-style.scss";

import * as database from "./dbInterface";
import { auth } from "./dbInterface";

// Home.html js to make it work!

// Add the Firebase products and methods that you want to use
import { onAuthStateChanged } from "firebase/auth";

// Document elements
const loginButton = document.getElementById("loginButton");

const loggedInPage = document.getElementById("loggedInPage");

import * as loginUI from "./loginUI.js";
async function configUI() {
  console.log("ConfigUI Running");
  loginUI.config("#firebaseui-auth-container", loginButton, auth);

  // Showing content for only logged-in users
  onAuthStateChanged(auth, (user) => {
    if (user) {
      loggedInPage.style.display = "block";
    } else {
      loggedInPage.style.display = "none";
    }
  });
}

// Table of all urls
const htmlTable = document.getElementById("redirectTable");
function updateTable(urls) {
  let table = document.createElement("TABLE");
  let tableBody = document.createElement("TBODY");
  table.appendChild(tableBody);

  // Headers
  let headerRow = document.createElement("TR");
  let longHeader = document.createElement("TH");
  longHeader.textContent = "Long URL";
  let shortHeader = document.createElement("TH");
  shortHeader.textContent = "Short URL";
  headerRow.appendChild(longHeader);
  headerRow.appendChild(shortHeader);
  tableBody.appendChild(headerRow);

  urls.forEach((r) => {
    let row = document.createElement("TR");
    let longCell = document.createElement("TD");
    longCell.textContent = r.longURL;
    let shortCell = document.createElement("TD");
    shortCell.innerHTML = `<a href='${r.shortURL}'>${r.shortURL}</a>`;
    row.appendChild(longCell);
    row.appendChild(shortCell);
    tableBody.appendChild(row);
  });

  htmlTable.innerHTML = "";
  htmlTable.appendChild(table);
  console.log("Table Updated!");
  /*
  let htmlString = urls
    .map(
      (r) => `
          <tr>
            <td>${r.longURL}</td>
            <td>${r.shortURL}</td>
          </tr>
  `
    )
    .join('')
    .trim();

  var template = document.createElement('template');
  template.innerHTML = htmlString;
  console.log(htmlString);
  htmlTable.appendChild(template.content);
  */
}
database.mainWithUpdate(updateTable).then(configUI);

// Create URL from
const form = document.getElementById("newURL");
const urlInput = document.getElementById("urlInput");
// Listen to the form submission
form.addEventListener("submit", async (e) => {
  // Prevent the default form redirect
  e.preventDefault();

  database.createURL(urlInput.value);

  // clear message input field
  urlInput.value = "";
  // Return false to avoid redirect
  return false;
});

// Remove all button
const removeAllButton = document.getElementById("removeAll");

removeAllButton.addEventListener("click", (e) => {
  database.removeAllData().then(() => {
    window.location.reload();
  });
});
